import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthProvider";
import { ChevronRightIcon, InfoCircleIcon, LockIcon, LogOutIcon } from "../../../constants/Icons";

const AccountControl = () => {
  const { isUser, handleLogout } = useAuth();
  const navigate = useNavigate();

  const handleDelete = () => {
    navigate("/delete-account");
  };
  const handleReset = () => {
    navigate("/reset", {
      replace: true,
      state: {
        email: isUser.email,
      },
    });
  };
  const handleResetAccount = () => {
    navigate("/confirm-reset-account", {
      replace: true,
      state: {
        email: isUser.email,
      },
    });
  };

  return (
    <>
      <div className="card">
        <div className="card-header p-3">
          <h6 className="mb-0 text-dark">Security</h6>
        </div>
        <div className="card-body">
          <div class="d-flex align-items-center border radius-10 p-2">
            <div class="flex-shrink-0 me-3">
              <div class="widgets-icons-small text-grey bg-light-grey">
                <LockIcon/>
              </div>
            </div>
            <div class="flex-grow-1 d-flex align-items-center justify-content-between">
              <div class="mb-0">
                <h6 className="mb-0 text-grey">Reset Password</h6>
                <p className="mb-0 text-muted fs-13">
                  Resetting your password is permanent and cannot be reversed.
                  Please confirm you want to proceed.
                </p>
              </div>
              <div class="text-end">
                <div className="order-actions">
                  <button
                    className="btn btn-label-info shadow-none"
                    onClick={handleReset}
                  >
                    <ChevronRightIcon/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header p-3">
          <h6 className="mb-0 text-dark">Reset Account</h6>
        </div>
        <div className="card-body">
          <div class="d-flex align-items-center border radius-10 p-2">
            <div class="flex-shrink-0 me-3">
              <div class="widgets-icons-small text-grey bg-light-grey">
                <LockIcon/>
              </div>
            </div>
            <div class="flex-grow-1 d-flex align-items-center justify-content-between">
              <div class="mb-0">
                <h6 className="mb-0 text-grey">Reset Account</h6>
                <p className="mb-0 text-muted fs-13">
                  Resetting your account is permanent and cannot be reversed.
                  Please confirm you want to proceed.
                </p>
              </div>
              <div class="text-end">
                <div className="order-actions">
                  <button
                    className="btn btn-label-info shadow-none"
                    onClick={handleResetAccount}
                  >
                    <ChevronRightIcon/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header p-3">
          <h6 className="mb-0 text-dark">Deactivate Account</h6>
        </div>
        <div className="card-body">
          <div class="d-flex align-items-center border radius-10 p-2">
            <div class="flex-shrink-0 me-3">
              <div class="widgets-icons-small text-grey bg-light-grey">
                <InfoCircleIcon/>
              </div>
            </div>
            <div class="flex-grow-1 d-flex align-items-center justify-content-between">
              <div class="mb-0">
                <h6 className="mb-0 text-grey">Delete Account</h6>
                <p className="mb-0 text-muted fs-13">
                  Once you delete your account, there is no going back. Please
                  be certain.
                </p>
              </div>
              <div class="text-end">
                <div className="order-actions">
                  <button
                    className="btn btn-label-danger shadow-none"
                    onClick={handleDelete}
                  >
                    <ChevronRightIcon/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        {" "}
        <button
          type="button"
          className="btn btn-danger text-right"
          onClick={handleLogout}
        >
          <LogOutIcon/> Logout
        </button>
      </div>
    </>
  );
};

export default AccountControl;
